import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { paymentModeAction } from "../../store/paymentModes/action";
export var GetPaymentMode = function (trigger, projectId) {
    var dispatch = useDispatch();
    var enable = useState(true)[0];
    var page = useState(1)[0];
    var limit = useState(100)[0];
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePaymentMode: (_a = state.PaymentMode.responsePaymentMode) === null || _a === void 0 ? void 0 : _a.data,
            errorPaymentMode: state.PaymentMode.errorPaymentMode,
            loadingPaymentMode: state.PaymentMode.loadingPaymentMode,
        });
    }), responsePaymentMode = _a.responsePaymentMode, errorPaymentMode = _a.errorPaymentMode, loadingPaymentMode = _a.loadingPaymentMode;
    useEffect(function () {
        if (trigger) {
            dispatch(paymentModeAction({
                enable: enable,
                page: page,
                limit: limit,
                projectId: projectId,
                deleted: false,
            }));
        }
    }, [trigger]);
    return {
        responsePaymentMode: responsePaymentMode,
        errorPaymentMode: errorPaymentMode,
        loadingPaymentMode: loadingPaymentMode,
    };
};
